import type { Script } from './types';

const SCRIPT_FONT_STACKS: Record<Script, string> = {
  latin: '"Space Grotesk", system-ui, sans-serif',
  cyrillic: '"Space Grotesk", system-ui, sans-serif',
  cjk: '"Noto Sans CJK", "Hiragino Sans", "Yu Gothic", "Microsoft YaHei", system-ui, sans-serif',
  arabic: '"Noto Sans Arabic", "Tahoma", system-ui, sans-serif',
  devanagari: '"Noto Sans Devanagari", "Mangal", system-ui, sans-serif',
  bengali: '"Noto Sans Bengali", "Vrinda", system-ui, sans-serif',
  tamil: '"Noto Sans Tamil", "Latha", system-ui, sans-serif',
  telugu: '"Noto Sans Telugu", "Gautami", system-ui, sans-serif',
  gujarati: '"Noto Sans Gujarati", "Shruti", system-ui, sans-serif',
  gurmukhi: '"Noto Sans Gurmukhi", "Raavi", system-ui, sans-serif',
  thai: '"Noto Sans Thai", "Leelawadee UI", system-ui, sans-serif',
};

export function fontFamilyForScript(script: Script): string {
  return SCRIPT_FONT_STACKS[script];
}
